import $ from 'jquery';

export default () => {
    // Temporary shameful JS
    let $page_alert = $('.page__alert'),
        hide_alert = (ev) => {
            if (!! ev) {
                ev.preventDefault();
            }
            $page_alert.slideUp(500, function () {
                $page_alert.filter('.page__alert--flash').off('click', '.close');
                $page_alert.filter('.page__alert--flash').remove();
            });
        };
    if (!! $page_alert.length && $page_alert.hasClass('page__alert--flash')) {
        setTimeout(hide_alert, 3000);
    }

    $('.page').on('click', '.page__alert .close', hide_alert);
}
